const state = () => ({
  items: null,
});

const actions = {
  update({ commit }, menuProducts) {
    commit("UPDATE", menuProducts);
  },
};

const getters = {
  bySection({ items }) {
    if (!items) {
      return Object.create(null);
    }

    let groupedItems = items.reduce((r, a) => {
      r[a.section] = r[a.section] || [];
      r[a.section].push(a);

      if (a.pricebook_info.promotions.length) {
        r['Specials'] = r['Specials'] || [];
        if (!r['Specials'].some(s => s.upc === a.upc)) {
          r['Specials'].push(a);
        }
      }
      return r;
    }, Object.create(null));

    // alphabetize the sections
    const sortedSections = Object.keys(groupedItems).sort();

    // create a new object with sorted sections
    const alphabetizedGroupedItems = Object.create(null);
    sortedSections.forEach(section => {
      alphabetizedGroupedItems[section] = groupedItems[section];
    });

    return alphabetizedGroupedItems;
  },
};

const mutations = {
  UPDATE(state, payload) {
    state.items = payload;
  },
};

export default {
  namespaced: true,
  state,
  actions,
  getters,
  mutations,
};
